import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Chip,
  Link,
  Box,
  DialogActions,
  Button,
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import {
  closeJobsDialog,
  acknowledgeJob,
  clearAllJobs,
} from '../../redux/confluence/confluenceJobsSlice';

export default function ConfluenceExportJobsDialog() {
  const dispatch = useDispatch();

  // Read from Redux
  const { open, jobs } = useSelector((state) => state.confluenceJobs);

  return (
    <Dialog open={open} onClose={() => dispatch(closeJobsDialog())} maxWidth="md" fullWidth>
      <DialogTitle sx={{ fontWeight: 500 }}>Confluence Export Jobs</DialogTitle>

      <DialogContent>
        {jobs.length === 0 ? (
          <Box sx={{ mt: 3, textAlign: 'center', color: 'text.secondary' }}>
            No active export jobs
          </Box>
        ) : (
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Job ID</TableCell>
                <TableCell>Regression Test ID</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Confluence Doc</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {jobs.map((job) => (
                <TableRow key={job.jobId}>
                  <TableCell>{job.jobId}</TableCell>
                  <TableCell>{job.regressionTestId}</TableCell>

                  <TableCell>
                    <Chip
                      label={job.status}
                      color={
                        job.status === 'COMPLETED'
                          ? 'success'
                          : job.status === 'FAILED'
                            ? 'error'
                            : 'info'
                      }
                      size="small"
                    />
                  </TableCell>

                  <TableCell>
                    {job.confluenceUrl ? (
                      <Link
                        href={job.confluenceUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={() => dispatch(acknowledgeJob(job.jobId))}
                      >
                        Open
                      </Link>
                    ) : (
                      '-'
                    )}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </DialogContent>
      <DialogActions
        sx={{
          justifyContent: 'space-between',
          px: 3,
          py: 2,
        }}
      >
        {/* Clear all */}
        {jobs.length > 0 ? (
          <Button
            onClick={() => {
              if (window.confirm('Clear all Confluence export jobs?')) {
                dispatch(clearAllJobs());
              }
            }}
            sx={{
              backgroundColor: 'error.dark', // red background
              color: 'background.paper', // white text
              textTransform: 'none',
              fontWeight: 400,
              px: 1, // horizontal padding
              py: 0.5, // vertical padding
              minHeight: 30,
              '&:hover': {
                backgroundColor: 'error.dark',
              },
            }}
          >
            CLEAR ALL
          </Button>
        ) : (
          <span /> // keeps spacing balanced
        )}

        {/* Close */}
        <Button
          onClick={() => dispatch(closeJobsDialog())}
          sx={{
            color: 'text.secondary',
            textTransform: 'none',
            '&:hover': {
              backgroundColor: 'action.hover',
            },
          }}
        >
          CLOSE
        </Button>
      </DialogActions>
    </Dialog>
  );
}
